'use client';

import NextLink from 'next/link';
import { useLocale } from 'next-intl';
import { getPathname, usePathname } from '@/i18n/navigation';
import { routing } from '@/i18n/routing';
import { cn } from '@/lib/utils';

const LABEL: Record<string, string> = { ru: 'RU', en: 'EN' };

export function LocaleSwitcher() {
  const active = useLocale();
  // Путь уже без префикса локали — та же страница открывается в другом языке.
  const pathname = usePathname();

  return (
    <nav aria-label="Language" className="flex items-center gap-1 text-sm">
      {routing.locales.map((locale, idx) => (
        <span key={locale} className="flex items-center gap-1">
          {idx > 0 && <span aria-hidden="true" className="text-border">/</span>}
          <NextLink
            // Не Link из i18n/navigation: с явной локалью он префиксует и русский путь.
            href={getPathname({ href: pathname, locale })}
            hrefLang={locale}
            lang={locale}
            aria-current={locale === active ? 'true' : undefined}
            className={cn(
              'rounded px-1 transition-colors',
              locale === active
                ? 'font-medium text-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {LABEL[locale]}
          </NextLink>
        </span>
      ))}
    </nav>
  );
}
